let englishI18n = null;

export const getEnglishI18n = mainI18n => {
    if (!englishI18n && mainI18n) {
        englishI18n = mainI18n.cloneInstance({});
        englishI18n.changeLanguage("en-GB");
    }
    return englishI18n;
};

export const getEnglishTranslation = (key, fallback, mainI18n) => {
    const englishInstance = getEnglishI18n(mainI18n);
    return englishInstance ? englishInstance.t(key, fallback) : fallback;
};
